import SendIcon from '@mui/icons-material/Send';
import {
  Backdrop,
  Box,
  Card,
  CardHeader,
  CardContent,
  Collapse,
  CircularProgress,
  Grid,
  IconButton,
  Button,
  TextField,
  Typography,
  Alert,
  Stack,
  Snackbar
} from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { orange } from '@mui/material/colors';
import Tooltip from '@mui/material/Tooltip';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import RefreshIcon from '@mui/icons-material/Refresh';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { confirmAlert } from 'react-confirm-alert';
import { useDispatch, useSelector } from 'react-redux';
import { generalFollowActions } from 'src/store/slices/generalFollowSlice';
import axios from 'src/utils/axios';
import { getUser, getUserRole } from 'src/utils/Common';
import TagFacesIcon from '@mui/icons-material/TagFaces';
import DeleteSweepIcon from '@mui/icons-material/DeleteSweep';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  mainCard: {
    border: '1px solid #e0e0e0',
    borderRadius: '16px',
    position: 'sticky',
    top: 280,
    zIndex: 6,
    backgroundColor: '#fff',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    marginBottom: '16px'
  },
  cardHeader: {
    backgroundColor: '#f5f5f5',
    color: '#424242',
    padding: '10px 16px',
    cursor: 'move',
    borderBottom: '1px solid #e0e0e0',
    '& .MuiCardHeader-title': {
      fontSize: '12px',
      fontWeight: '700',
      letterSpacing: '0.5px'
    }
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)'
    },
    '100%': {
      transform: 'rotate(360deg)'
    }
  },
  spinning: {
    animation: '$spin 1s linear infinite'
  }
}));

function SapRefundProcess() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const SessionUser = getUser();
  const Role = getUserRole().RoleId;

  const invoiceData = useSelector(
    (state) => state.generalFollowSlice.invoiceDetail
  );
  const UpdatedInformation = useSelector(
    (state) => state.generalFollowSlice.updatedProductInformation
  );

  const [refundInvoiceNo, setRefundInvoiceNo] = React.useState(
    invoiceData[0]?.Exchange?.RefundInvoiceNumber
      ? invoiceData[0]?.Exchange?.RefundInvoiceNumber
      : ''
  );
  const [refundCustomerTc, setRefundCustomerTc] = React.useState(
    invoiceData[0]?.Exchange?.RefundCustomerTC
  );
  const [refundCustomerName, setRefundCustomerName] = React.useState(
    invoiceData[0]?.Exchange?.RefundCustomerName
  );
  const [uyari, setUyari] = React.useState(false);
  const [uyariClose, setUyariClose] = React.useState('error');
  const [loading, setLoading] = React.useState(false);
  const [serviceTakeCustomerProduct, setServiceTakeCustomerProduct] =
    React.useState(invoiceData[0]?.Exchange?.ServiceTakeCustomerProduct);
  const [collapsed, setCollapsed] = React.useState(false);
  const [refreshing, setRefreshing] = React.useState(false);

  const [responseMessage, setresponseMessage] = React.useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });
  function pageUpdate() {
    dispatch(generalFollowActions.updateActiveTab('1'));
  }

  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const handleRefresh = () => {
    setRefreshing(true);
    setTimeout(() => setRefreshing(false), 500);
  };

  const handleToggleCollapse = () => {
    setCollapsed(!collapsed);
  };

  function removeRowInTable() {
    const orjinalData = [...UpdatedInformation];
    const removeRow = orjinalData?.findIndex(
      (x) => x.FIS_NO == invoiceData[0]?.Apply?.ReceiptNumber
    );
    orjinalData.splice(removeRow, 1);
    const xd = orjinalData.length;
    dispatch(generalFollowActions.updateProductInformation(orjinalData));
    dispatch(generalFollowActions.updateRowCount(xd));
  }

  function changeRefundCustomerTc(val) {
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Exchange.RefundCustomerTC = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setRefundCustomerTc(val);
  }

  function changeRefundCustomerName(val) {
    var tempData = JSON.parse(JSON.stringify(invoiceData));
    tempData[0].Exchange.RefundCustomerName = val;
    dispatch(generalFollowActions.updateNewData(tempData));
    setRefundCustomerName(val);
  }

  // Değişim çeki fişi 29 (Servisin eski ürünü alması bekleniyor) durumundayken
  // servis eski ürünü teslim almadığı için mali işlere gönderim yapılamaz
  const isWaitingServiceOldProduct =
    invoiceData[0]?.Consumer?.UpTypeId == 7 &&
    invoiceData[0]?.Exchange?.Status == 29;

  const data = {
    ServiceNumber: invoiceData[0]?.Exchange?.Service?.toString(), //Servis Numarası
    ApplicationNumber: invoiceData[0]?.Exchange?.ApplyNo?.toString(), //Başvuru No
    CustomerType: invoiceData[0]?.Consumer?.ConsumerType, //Müşteri tipi
    TopConfirmType: invoiceData[0]?.Consumer?.UpTypeId, //Üst onay türü
    GiveProductPrice: invoiceData[0]?.Exchange?.GiveProductPrice, //verilen ürün prekande fiyat
    ProductBuyStockPrice: invoiceData[0]?.Exchange.ReceivedProductPrice, //alınan ürün prekande fiyat
    PaymentCustomerTC: invoiceData[0]?.Exchange.RefundCustomerTC, //Tc müşteri
    PaymentCustomerName: invoiceData[0]?.Exchange.RefundCustomerName //müşteri ad
  };
  function sendRefund() {
    confirmAlert({
      message:
        'Müşterinin para iadesi işlemleri için belgeleri hazırladığınızı ve mali işlere ilettiğinizi belirtiyorsunuz. Onaylıyor musunuz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            setLoading(true);
            axios
              .post('SetRefund', data, {
                headers: { 'Content-Type': 'application/json' }
              })
              .then((response) => {
                if (response.data.ErrorCode == 0) {
                  setRefundInvoiceNo(response.data.Description);
                  setLoading(false);
                  setUyari(true);
                  setUyariClose('success');
                  setresponseMessage({
                    ErrorCode: 0,
                    ErrorDescription: 'İşleminiz Başarı ile Gerçekleşmiştir'
                  });
                  removeRowInTable();
                  setTimeout(pageUpdate, 500);
                  return;
                } else {
                  setUyari(true);
                  setUyariClose('error');
                  setresponseMessage({
                    ErrorCode: 1000,
                    ErrorDescription: response.data.ErrorDescription
                  });
                  setLoading(false);
                  return;
                }
              })
              .catch((err) => {
                setUyariClose('error');
                setresponseMessage({
                  ErrorCode: 0,
                  ErrorDescription: 'Bir hata oluştu!...'
                });
                setLoading(false);
                return;
              });
          }
        },
        {
          label: 'Hayır',
          onClick: () => {}
        }
      ]
    });
  }

  function TakeService(check) {
    if (check == false) {
      confirmAlert({
        message:
          'Servis tarafından seçilen ayarı değiştirmek üzeresiniz! Emin misiniz?',
        buttons: [
          {
            label: 'Evet',
            onClick: () => {
              setLoading(true);
              const data = {
                isServiceGetProduct: check,
                ApplicationNumber: invoiceData[0]?.Exchange?.ApplyNo.toString(),
                ServiceNumber: invoiceData[0]?.Exchange?.Service.toString(),
                UserID: invoiceData[0]?.UserID
              };
              setServiceTakeCustomerProduct(check);
              setLoading(true);
              axios
                .post('BackToProductService', data, {
                  headers: { 'Content-Type': 'application/json' }
                })
                .then((response) => {
                  if (response.data == true) {
                    setresponseMessage({
                      ErrorCode: 1000,
                      ErrorDescription: 'İşleminiz Başarı ile Gerçekleşmiştir'
                    });
                    setUyariClose('success');
                    setUyari(true);
                    setLoading(false);
                    removeRowInTable();
                    setTimeout(pageUpdate, 500);
                    return;
                  } else {
                    setUyari(true);
                    setUyariClose('error');
                    setresponseMessage({
                      ErrorCode: 0,
                      ErrorDescription: 'Bir hata oluştu!...'
                    });
                    setLoading(false);
                    return;
                  }
                })
                .catch((err) => {
                  setLoading(false);
                  return;
                });
            }
          },
          {
            label: 'Hayır',
            onClick: () => {}
          }
        ]
      });
    }
  }

  function ParaIadesiBelgeNoTemizle() {
    const data = {
      ServiceNumber: invoiceData[0]?.Exchange?.Service?.toString(), //Servis Numarası
      ApplicationNumber: invoiceData[0]?.Exchange?.ApplyNo?.toString(), //Başvuru No
      SessionUser: SessionUser?.UserId?.toString() //Sicil No
    };
    setLoading(true);
    axios
      .post('ParaIadesiBelgeNoSil', data, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then((response) => {
        if (response.data.ErrorCode == 0) {
          setLoading(false);
          setUyari(true);
          setUyariClose('success');
          setresponseMessage({
            ErrorCode: 0,
            ErrorDescription: 'İşleminiz Başarı ile Gerçekleşmiştir'
          });
          removeRowInTable();
          setTimeout(pageUpdate, 500);
          return;
        } else {
          setUyari(true);
          setUyariClose('error');
          setresponseMessage({
            ErrorCode: 1000,
            ErrorDescription: response.data.ErrorDescription
          });
          setLoading(false);
          return;
        }
      });
    setLoading(false);
  }

  return (
    <>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Stack spacing={8}>
        <Snackbar
          sx={{ width: '100%' }}
          open={uyari}
          autoHideDuration={6000}
          onClose={uyariKapat}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center'
          }}
        >
          <Alert
            icon={<TagFacesIcon />}
            style={{ minWidth: 500 }}
            sx={{
              '& .MuiAlert-icon': {
                color: 'white'
              },
              height: 75,
              alignItems: 'center',
              verticalAlign: 'center'
            }}
            onClose={uyariKapat}
            variant="filled"
            severity={uyariClose}
          >
            {responseMessage.ErrorDescription}
          </Alert>
        </Snackbar>
      </Stack>

      {invoiceData[0].Consumer.UpTypeId != 7 ? (
        <>
          <Card className={classes.mainCard}>
            <CardHeader
              className={classes.cardHeader}
              avatar={<DragIndicatorIcon sx={{ color: '#FF9800' }} />}
              action={
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Tooltip title={collapsed ? 'Genişlet' : 'Daralt'}>
                    <IconButton
                      onClick={handleToggleCollapse}
                      sx={{ color: '#FF9800' }}
                    >
                      {collapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                    </IconButton>
                  </Tooltip>
                </Box>
              }
              title="Para İadesi Ödeme Yapılacak Kişi Farklı ise"
            />
            <Collapse in={!collapsed} timeout="auto" unmountOnExit>
              <CardContent sx={{ padding: '10px 12px' }}>
                <Grid container spacing={1} alignItems="center">
                  <Grid item xs={1} md={1}>
                    <Tooltip title="Ürünün Eskisi Yetkili Servisimiz Tarafından Teslim alınmıştır">
                      <Checkbox
                        checked={serviceTakeCustomerProduct}
                        onChange={(event) => {
                          TakeService(event.target.checked);
                        }}
                        sx={{
                          color: orange[800],
                          '&.Mui-checked': {
                            color: orange[600]
                          }
                        }}
                      />
                    </Tooltip>
                  </Grid>
                  <Grid item xs={5} md={5}>
                    <Tooltip title="Ödeme yapılacak kişi farklı ise">
                      <TextField
                        id="input-with-icon-textfield"
                        label="TC Kimlik"
                        size="small"
                        fullWidth
                        variant="outlined"
                        disabled={
                          invoiceData[0]?.Exchange?.RefundIs == true
                            ? true
                            : false
                        }
                        value={refundCustomerTc}
                        onChange={(event) => {
                          changeRefundCustomerTc(event.target.value);
                        }}
                        InputLabelProps={{
                          style: { fontSize: '10px', color: '#757575' }
                        }}
                        InputProps={{
                          style: { fontSize: '11px' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px'
                          }
                        }}
                      />
                    </Tooltip>
                  </Grid>
                  <Grid item xs={6} md={6}>
                    <Tooltip title="Ödeme yapılacak kişi farklı ise">
                      <TextField
                        id="input-with-icon-textfield"
                        label="İsim Soyisim"
                        size="small"
                        fullWidth
                        variant="outlined"
                        disabled={
                          invoiceData[0]?.Exchange?.RefundIs == true
                            ? true
                            : false
                        }
                        value={refundCustomerName}
                        onChange={(event) => {
                          changeRefundCustomerName(event.target.value);
                        }}
                        InputLabelProps={{
                          style: { fontSize: '10px', color: '#757575' }
                        }}
                        InputProps={{
                          style: { fontSize: '11px' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px'
                          }
                        }}
                      />
                    </Tooltip>
                  </Grid>
                  {(invoiceData[0]?.Consumer?.UpTypeId == 2 ||
                    invoiceData[0]?.Consumer?.UpTypeId == 6) &&
                  (invoiceData[0]?.Exchange?.Status == 15 ||
                    invoiceData[0]?.Exchange?.Status == 16 ||
                    invoiceData[0]?.Exchange?.Status == 17) ? (
                    <>
                      <Grid item xs={6} md={6}>
                        <Tooltip title="Belge Numarası">
                          <TextField
                            id="input-with-icon-textfield"
                            label="Belge Numarası"
                            size="small"
                            fullWidth
                            variant="outlined"
                            disabled
                            value={refundInvoiceNo ? refundInvoiceNo : ''}
                            onChange={(event) => {
                              setRefundInvoiceNo(event.target.value);
                            }}
                            InputLabelProps={{
                              style: { fontSize: '10px', color: '#757575' }
                            }}
                            InputProps={{
                              style: { fontSize: '11px' }
                            }}
                            sx={{
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '8px'
                              }
                            }}
                          />
                        </Tooltip>
                      </Grid>
                      <Grid
                        item
                        xs={6}
                        md={6}
                        sx={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'center'
                        }}
                      >
                        {Role?.filter((i) => i.ROLE_ID == 7).length > 0 &&
                        invoiceData[0]?.Exchange?.RefundInvoiceNumber?.length >
                          0 ? (
                          <Tooltip title="Belge Numarası Sil">
                            <IconButton
                              className={classes.action}
                              size="small"
                              sx={{
                                background:
                                  'linear-gradient(135deg, #424242 0%, #616161 100%)',
                                borderRadius: '8px',
                                padding: '6px',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  background:
                                    'linear-gradient(135deg, #616161 0%, #757575 100%)',
                                  boxShadow: '0 4px 12px rgba(255,152,0,0.3)',
                                  transform: 'translateY(-2px)'
                                }
                              }}
                              onClick={() => {
                                ParaIadesiBelgeNoTemizle();
                              }}
                            >
                              <DeleteSweepIcon
                                sx={{ color: '#FF9800', fontSize: '18px' }}
                              />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title="Gönder">
                            <IconButton
                              className={classes.action}
                              size="small"
                              key="close"
                              sx={{
                                backgroundColor: '#424242',
                                borderRadius: '8px',
                                padding: '6px',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                  backgroundColor: '#616161',
                                  boxShadow: '0 4px 12px rgba(255,152,0,0.3)',
                                  transform: 'translateY(-2px)'
                                }
                              }}
                              onClick={() => {
                                sendRefund();
                              }}
                            >
                              <SendIcon
                                sx={{ color: '#FF9800', fontSize: '18px' }}
                              />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Grid>
                    </>
                  ) : null}
                </Grid>
              </CardContent>
            </Collapse>
          </Card>
        </>
      ) : (
        <>
          {/* Değişim Çeki mali işlere gönderme kısmı buraya gelecek */}
          <Card className={classes.mainCard}>
            <CardHeader
              className={classes.cardHeader}
              avatar={<DragIndicatorIcon sx={{ color: '#FF9800' }} />}
              action={
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <Tooltip title={collapsed ? 'Genişlet' : 'Daralt'}>
                    <IconButton
                      onClick={handleToggleCollapse}
                      sx={{ color: '#FF9800' }}
                    >
                      {collapsed ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                    </IconButton>
                  </Tooltip>
                </Box>
              }
              title="Değişim Çeki Belge Numarası"
            />
            <Collapse in={!collapsed} timeout="auto" unmountOnExit>
              <CardContent sx={{ padding: '10px 12px' }}>
                <Grid container spacing={1} alignItems="center">
                  <Grid item xs={1} md={1}>
                    <Tooltip title="Ürünün Eskisi Yetkili Servisimiz Tarafından Teslim alınmıştır">
                      <Checkbox
                        checked={serviceTakeCustomerProduct}
                        onChange={(event) => {
                          TakeService(event.target.checked);
                        }}
                        sx={{
                          color: orange[800],
                          '&.Mui-checked': {
                            color: orange[600]
                          }
                        }}
                      />
                    </Tooltip>
                  </Grid>
                  <Grid item xs={8} md={8}>
                    <Tooltip title="Belge Numarası">
                      <TextField
                        id="input-with-icon-textfield"
                        label="Belge Numarası"
                        size="small"
                        fullWidth
                        variant="outlined"
                        disabled
                        value={refundInvoiceNo ? refundInvoiceNo : ''}
                        onChange={(event) => {
                          setRefundInvoiceNo(event.target.value);
                        }}
                        InputLabelProps={{
                          style: { fontSize: '10px', color: '#757575' }
                        }}
                        InputProps={{
                          style: { fontSize: '11px' }
                        }}
                        sx={{
                          '& .MuiOutlinedInput-root': {
                            borderRadius: '8px'
                          }
                        }}
                      />
                    </Tooltip>
                  </Grid>
                  <Grid
                    item
                    xs={3}
                    md={3}
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center'
                    }}
                  >
                    {invoiceData[0]?.Consumer?.UpTypeId == 7 &&
                    invoiceData[0]?.Consumer?.ConsumerType != 3 &&
                    (invoiceData[0]?.Exchange?.Status == 15 ||
                      invoiceData[0]?.Exchange?.Status == 16 ||
                      invoiceData[0]?.Exchange?.Status == 17) &&
                    Role?.filter((i) => i.ROLE_ID == 7).length > 0 &&
                    invoiceData[0]?.Exchange?.RefundInvoiceNumber?.length >
                      0 ? (
                      <Tooltip title="Belge Numarası Sil">
                        <IconButton
                          className={classes.action}
                          size="small"
                          sx={{
                            background:
                              'linear-gradient(135deg, #424242 0%, #616161 100%)',
                            borderRadius: '8px',
                            padding: '6px',
                            transition: 'all 0.3s ease',
                            '&:hover': {
                              background:
                                'linear-gradient(135deg, #616161 0%, #757575 100%)',
                              boxShadow: '0 4px 12px rgba(255,152,0,0.3)',
                              transform: 'translateY(-2px)'
                            }
                          }}
                          onClick={() => {
                            ParaIadesiBelgeNoTemizle();
                          }}
                        >
                          <DeleteSweepIcon
                            sx={{ color: '#FF9800', fontSize: '18px' }}
                          />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip
                        title={
                          isWaitingServiceOldProduct
                            ? 'Servisin eski ürünü teslim alması bekleniyor. Teslim alınmadan gönderilemez.'
                            : 'Gönder'
                        }
                      >
                        {/* Pasif butonda da tooltip görünsün diye span ile sarıldı */}
                        <span>
                          <IconButton
                            className={classes.action}
                            size="small"
                            key="close"
                            disabled={isWaitingServiceOldProduct}
                            sx={{
                              backgroundColor: '#424242',
                              borderRadius: '8px',
                              padding: '6px',
                              transition: 'all 0.3s ease',
                              '&:hover': {
                                backgroundColor: '#616161',
                                boxShadow: '0 4px 12px rgba(255,152,0,0.3)',
                                transform: 'translateY(-2px)'
                              },
                              '&.Mui-disabled': {
                                backgroundColor: '#e0e0e0'
                              }
                            }}
                            onClick={() => {
                              sendRefund();
                            }}
                          >
                            <SendIcon
                              sx={{
                                color: isWaitingServiceOldProduct
                                  ? '#9e9e9e'
                                  : '#FF9800',
                                fontSize: '18px'
                              }}
                            />
                          </IconButton>
                        </span>
                      </Tooltip>
                    )}
                  </Grid>
                </Grid>
              </CardContent>
            </Collapse>
          </Card>
        </>
      )}
    </>
  );
}

export default SapRefundProcess;
